import styles from './style.postcss';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import is from 'is_js';
import { Grid, PageCard, connect, moment } from 'omni-common-ui';
import ExpansionGridItem from 'components/ExpansionGridItem';
import IndividualNote from './IndividualNote';
import * as studentNotesActions from './actions';

export class Note extends PureComponent {
  componentDidMount() {
    this.props.fetchStudentNotesIfNeeded(this.props.studentId);
  }

  componentWillReceiveProps(nextProps) {
    this.props.fetchStudentNotesIfNeeded(nextProps.studentId);
  }

  _renderNotes() {
    if (is.existy(this.props.studentNotes)) {
      return this.props.studentNotesSummary
        .sort((a, b) => {
          if (a.noteTime.isBefore(b.noteTime)) {
            return 1;
          }
          return - 1;
        })
        .map(
        (summary, stamp) => {
          const { ids } = summary;
          const noteSummary = ids.length === 1 ? '1 Note' : `${ids.length} Notes`;
          return <ExpansionGridItem title={stamp} summary={noteSummary}>
            {ids.map((id) => <IndividualNote key={id} note={this.props.studentNotes.get(id)} />)}
          </ExpansionGridItem>;
        });
    }
    return null;
  }

  render() {
    return <Grid className={styles.Note}>
      <Grid.Group className={styles.Note_wrapper}>
        <Grid.Item>
          <PageCard>
            <PageCard.Heading text="Notes" stackMode="horizontal" />
            <PageCard.Content className={styles.Note_card}>
              {this._renderNotes()}
            </PageCard.Content>
          </PageCard>
        </Grid.Item>
      </Grid.Group>
    </Grid>;
  }
}

Note.propTypes = {
  studentId: PropTypes.string,
  studentNotes: PropTypes.object,
  studentNotesSummary: PropTypes.object,
  fetchStudentNotesIfNeeded: PropTypes.func,
};

export function getSummary(notes) {
  let summary = new Map();
  if (Map.isMap(notes) && notes.size !== 0) {
    notes.forEach((note) => {
      const notedStamp =
        moment.utc(note.notedDateTimeUtc).local().format('YYYY-MM');
      if (summary.get(notedStamp)) {
        summary = summary.set(notedStamp, {
          ids: [...summary.get(notedStamp).ids, note.id],
          stamp: notedStamp,
          noteTime: note.notedDateTimeUtc,
        });
      } else {
        summary = summary.set(notedStamp, {
          ids: [note.id],
          stamp: notedStamp,
          noteTime: note.notedDateTimeUtc,
        });
      }
    });
  }
  return summary.map((group) => {
    const orderGroup = {
      stamp: group.stamp,
      ids: group.ids.sort((a, b) => {
        if (notes.get(a).notedDateTimeUtc
          .isBefore(notes.get(b).notedDateTimeUtc)) {
          return 1;
        }
        return - 1;
      }),
      noteTime: group.noteTime,
    };
    return orderGroup;
  });
}

export function mapStateToProps(state, ownProps) {
  const studentId = ownProps.studentId;
  const studentNotes =
    state
      .get('rootReducer')
      .get('studentNotes')
      .filter((note) => note.studentId === studentId);
  const studentNotesSummary = getSummary(studentNotes);
  return {
    studentId,
    studentNotes,
    studentNotesSummary,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(studentNotesActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Note);



// WEBPACK FOOTER //
// ./containers/Student/Note/component.jsx